













































































import { Vue, Component, Prop } from 'vue-property-decorator'
import type { Produto, ProdutoComVariantes } from '@/models'
import AppStore from '@/store/vuex/aplicacao/AppStore'
import { hashColor } from '@/shareds/badge-utils'

@Component
export default class CardDeInformacoesDoProduto extends Vue {
	@Prop({ type: Object, required: true }) produto!: Produto
	@Prop({ type: Boolean, default: true }) mostrar!: boolean
	@Prop({ type: String, default: 'https://i.pinimg.com/originals/61/3c/ea/613ceaae3543acdf381af20da47612dc.png' }) imagemPadrao!: string

	hashColor = hashColor

	get modoNoturno() {
		return AppStore.modoNoturno
	}

	get imagemDoProduto() {
		if (this.produto.urlImagens && this.produto.urlImagens.length > 0) {
			const imagemPadrao = this.produto.urlImagens.find(imagem => imagem.padrao)
			return imagemPadrao ? imagemPadrao.imagemUrl : this.imagemPadrao
		}
		return this.imagemPadrao
	}

	get fornecedorNome() {
		if (!this.produto.fornecedor) return '—'
		
		if (typeof this.produto.fornecedor === 'string') {
			return this.produto.fornecedor
		}
		
		return this.produto.fornecedor.razaoSocialOuNome || '—'
	}

	get eansDoProduto() {
		const eans: string[] = []
		
		if (this.produto.eans && this.produto.eans.length > 0) {
			eans.push(...this.produto.eans)
		}
		
		if (this.produto.tipo === 'Com Variantes') {
			const produtoComVariantes = this.produto as ProdutoComVariantes
			if (produtoComVariantes.variantes && produtoComVariantes.variantes.length > 0) {
				produtoComVariantes.variantes.forEach(variante => {
					if (variante.eans && variante.eans.length > 0) {
						eans.push(...variante.eans)
					}
				})
			}
		}
		
		return [...new Set(eans)]
	}
}
